const EarthRadius = 6378.137;
const metersToMilesDiff = 0.000621;

export const getDistance = (lat1: string | number, lon1: string | number, lat2: string | number, lon2: string | number) => {
    const dLat = Number(lat2) * Math.PI / 180 - Number(lat1) * Math.PI / 180;
    const dLon = Number(lon2) * Math.PI / 180 - Number(lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(Number(lat1) * Math.PI / 180) * Math.cos(Number(lat2) * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = EarthRadius * c;

    return Number((d * 1000 * metersToMilesDiff).toFixed(2));
};
